export default __webpack_public_path__ + "locales/bg/PeopleTranslations.json?hash=dc54e154c5835edcd98a876aba751f79";